import { useTranslations } from 'next-intl'

import { SERVICE_CARD_THEME } from '@/_components/sections/services/components/a-service-card'
import ZServices from '@/_components/sections/services/z-section-services'
import { useSectionParams } from '@/_i18n/section-params'

/**
 * Universal services section for annual program details.
 * Displays available health services with links to:
 * - Ambulance visits
 * - Annual programs (highlighted as favorite)
 * - Preventive examinations
 *
 * Uses translations for all content and section params for navigation links.
 * Shared across all annual program detail pages (Balance, Mini, Vital).
 *
 * @example
 * ```typescript
 * <ZAPDetailServices />
 * ```
 */
const ZAPDetailServices = () => {
	const t = useTranslations('health_services')
	const tComponents = useTranslations('components.services')

	const { getSectionParams: getAmbulanceParams } = useSectionParams('ambulances')
	const { getSectionParams: getAnnualParams } = useSectionParams('annualPrograms')
	const { getSectionParams: getPreventiveParams } = useSectionParams('preventiveExaminations')

	/**
	 * Service cards configuration.
	 * Each service includes header, title, description, theme, and link.
	 */
	const services = [
		{
			header: t('ambulance_visit.header'),
			title: t('ambulance_visit.title'),
			description: t('ambulance_visit.description'),
			theme: SERVICE_CARD_THEME.BLUE,
			link: `/ambulancie/#${getAmbulanceParams('chooseAmbulanceCategory')}`
		},
		{
			header: t('annual_program.header'),
			title: t('annual_program.title'),
			description: t('annual_program.description'),
			theme: SERVICE_CARD_THEME.ANNUAL,
			link: `/rocne-programy/#${getAnnualParams('chooseProgramCategory')}`,
			isFavorite: true
		},
		{
			header: t('preventive_checkup.header'),
			title: t('preventive_checkup.title'),
			description: t('preventive_checkup.description'),
			theme: SERVICE_CARD_THEME.PREVENTIVE,
			link: `/preventivne-prehliadky/#${getPreventiveParams('choosePreventiveExamination')}`
		}
	]

	return (
		<ZServices
			title={tComponents('sectionName')}
			subtitle={tComponents('title')}
			description={tComponents('description')}
			services={services}
			buttonText={t('ambulance_visit.buttonText')}
			background={false}
			className='pdb-0'
		/>
	)
}

export default ZAPDetailServices
